export default __webpack_public_path__ + "static/media/goshen25.a4884f78.jpg";